<template>
  <div class="xiaofeiquan">
    <mainPage></mainPage>
  </div>
</template>

<script>
  import mainPage from './mainPage'
  export default {
    name: "index",
    data() {
        return {
          loopOption: {
            time: 10000, //10秒
            list: [],
            timeM: 180000, //3分钟
            listM: []
          }
        }
    },
    created() {
      this.$store.commit('xiaofeiquanVue', this)
      if(this.$route.query.refresh) {
        console.log('启动轮询!')
        this.loop()
      }
    },
    methods: {
      loopAxios(url, options, callback) {
        if(!url)return;
        if(typeof url != 'string')return;
        //接口参数
        let item = { url, options, callback }
        this.getData(item)
        this.loopOption.list.push(item)
      },
      loopMAxios(url, options, callback) {
        if(!url)return;
        if(typeof url != 'string')return;
        //接口参数
        let item = { options, callback }
        this.getData(item)
        this.loopOption.listM.push(item)
      },
      loop() {
        //轮训队列
        this.loopT = setInterval(()=> {
          for(let i = 0; i < this.loopOption.list.length; i++) {
            this.getData(this.loopOption.list[i])
          }
        },this.loopOption.time)

        //慢点
        this.loopMT = setInterval(()=> {
          for(let i = 0; i < this.loopOption.listM.length; i++) {
            this.getData(this.loopOption.listM[i])
          }
        },this.loopOption.timeM)

      },
      getData(item) {
        //数据查询
        let url = process.env.VUE_APP_host + item.url
        this.$get(url, item.options).then(request => {
          item.callback && item.callback(request)
        })
      }
    },
    destroyed() {
      if(this.loopT) {
        clearInterval(this.loopT)
        this.loopT = null
      }
      if(this.loopMT) {
        clearInterval(this.loopMT)
        this.loopMT = null
      }
    },
    components: { mainPage }
  }
</script>

<style scoped>
  .xiaofeiquan {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
  }
</style>
